export { default } from './P'


// WEBPACK FOOTER //
// ./src/components/P/index.js